import { useState } from "react";
import { Button } from "@mui/material";
import { useRouter } from "next/router";
import { useTranslation } from "next-i18next";
import { WfHeading } from "src/components-mui/base/wf-heading/wf-heading";
import { WfDialog } from "src/components-mui/common/dialog/wf-dialog";
import { WfDialogFooter } from "src/components-mui/common/dialog/wf-dialog-footer";
import { SimpleRichText } from "src/components-mui/common/rich-text/simple-rich-text";
import { getGlobals } from "src/consts/globals";
import { useIsomorphicLayoutEffect } from "src/utils/common-util";

const NEWLY_REGISTERED_URL_PARAM = "isNewlyRegisteredUser";

export const WelcomeModal = () => {
    const { welcomeModal } = getGlobals() ?? {};
    const [isOpen, setIsOpen] = useState<boolean>(false);
    const { t } = useTranslation("common");
    const router = useRouter();

    useIsomorphicLayoutEffect(() => {
        if (!welcomeModal) {
            return;
        }

        setIsOpen(true);
    }, [welcomeModal]);

    const handleModalClose = () => {
        const url = new URL(window.location.href);
        url.searchParams.delete(NEWLY_REGISTERED_URL_PARAM);
        url.searchParams.delete(NEWLY_REGISTERED_URL_PARAM.toLowerCase());

        const newUrl = url.pathname + (url.search ? url.search : "");
        router.replace(newUrl, undefined, { shallow: true });
        setIsOpen(false);
    };

    const handleButtonClick = async () => {
        return handleModalClose();
    };

    return (
        <WfDialog isOpen={isOpen} onClose={handleModalClose}>
            <WfHeading component="h2" fontSize={{ xs: "xl", sm: "2xl" }} marginTop={[6, 0]}>
                {welcomeModal?.headline}
            </WfHeading>
            <SimpleRichText sx={{ mt: [2, 3] }} fontSize="md" text={welcomeModal?.description || ""} />
            <WfDialogFooter mt={5} gap={2} display="flex" justifyContent="flex-end" flexDirection={["column-reverse", "row"]}>
                {welcomeModal?.secondaryButton && (
                    <Button
                        component="a"
                        variant="outlined"
                        href={welcomeModal?.secondaryButton.url}
                        target={welcomeModal?.secondaryButton.target}
                        sx={{ width: ["100%", "auto"] }}
                    >
                        {welcomeModal?.secondaryButton.name}
                    </Button>
                )}
                <Button onClick={handleButtonClick} sx={{ width: ["100%", "auto"] }}>
                    {t("continue")}
                </Button>
            </WfDialogFooter>
        </WfDialog>
    );
};
